import { render, staticRenderFns } from "./LongRealizedOrdersPopup.vue?vue&type=template&id=4122287e&"
import script from "./LongRealizedOrdersPopup.vue?vue&type=script&lang=js&"
export * from "./LongRealizedOrdersPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports